module.exports = __webpack_public_path__ + "static/17_planning-sketches.e8fa26d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/auspost/17_planning-sketches.jpg
// module id = 489
// module chunks = 110568472390859